import React, { useState } from "react";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import { Helmet } from "react-helmet";
import "./parciality.css";
import Swal from "sweetalert2";
import { FaTimes, FaPlus, FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { createRoot } from "react-dom/client";
import axios from "axios";
import ContenedoresActivos from "./contentAcvites";

function Consolidated({ masterNumber, dataMaster, onBack  }) {
  const { master, houses, merchandise_types, booking_flights } = dataMaster;

  const [formErrors, setFormErrors] = useState({});
  const [housesState, setHousesState] = useState(houses);
  const [rows, setRows] = useState(booking_flights);
  const [error, setError] = useState("");
  const currentYear = new Date().getFullYear();
  const [rowErrors, setRowErrors] = useState([]);
  const [formData, setFormData] = useState({
    master: master.master,
    origenInicial: master.origin,
    origen: master.final_origin,
    destino: master.destiny,
    destinoFinal: master.final_destination,
    piezas: master.pieces,
    grossWeight: master.weight,
    chargeableWeight: master.chargeable_weight,
    volumen: master.volume,
    tipo: master.merchandise_type,
    descripcion: master.description,
  });

  const handleRedirectToPreCapture = () => {
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    if (formErrors[field]) {
      setFormErrors({ ...formErrors, [field]: "" });
    }
  };

  const anioOptions = Array.from(
    { length: new Date().getFullYear() + 2 - 2019 }, // Este cálculo genera el número de años desde 2019 hasta el año actual + 1
    (_, i) => 2019 + i
  );

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    setRows([...rows, { flight: "", year: currentYear.toString(), time: "" }]);
  };

  const handleRowInputChange = (index, field, value) => {
    const updatedRows = [...rows];

    if (field === "vuelo") {
      value = value.toUpperCase();

      // Si no contiene la diagonal pero tiene más de 2 caracteres (mínimo aerolínea + número)
      if (!value.includes("/") && value.length > 2) {
        const letras = value.slice(0, 2);
        const numerosYFecha = value.slice(2);

        const match = numerosYFecha.match(/^(\d{1,4})(\d{0,2}[A-Z]*)$/);
        if (match) {
          const numero = match[1].padStart(4, "0");
          const fecha = match[2];
          value = `${letras}${numero}/${fecha}`;
        }
      }

      // Oculta el error si empieza a ingresar un valor válido
      if (value.length > 0 && rowErrors[index]?.vuelo) {
        const updatedErrors = [...rowErrors];
        updatedErrors[index] = {
          ...updatedErrors[index],
          vuelo: "", // limpia solo el error de vuelo
        };

        if (field === "hora" && value.trim() !== "" && rowErrors[index]?.hora) {
          const updatedErrors = [...rowErrors];
          updatedErrors[index] = {
            ...updatedErrors[index],
            hora: "", // limpia solo el error de hora
          };
        }

        setRowErrors(updatedErrors);
      }
    }

    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const guardarAlert = async () => {
    const errors = {};
    setError([]);
    const requiredFields = [
      "origenInicial",
      "origen",
      "piezas",
      "destino",
      "destinoFinal",
      "grossWeight",
      "chargeableWeight",
      "volumen",
      "tipo",
      "descripcion",
    ];

    // Validar campos individuales del formulario
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].toString().trim() === "") {
        errors[field] = "Este campo es obligatorio";
      }
    });

    // Validar campos de cada fila en rows (vuelo, anio, hora)
    const rowErrors = rows.map((row) => {
      const err = {};
      if (!row.flight || row.flight.trim() === "")
        err.flight = "Este campo es obligatorio";
      if (!row.year || row.year.toString().trim() === "")
        err.year = "Este campo es obligatorio";
      if (!row.time || row.time.trim() === "")
        err.time = "Este campo es obligatorio";
      return err;
    });

    // Verifica si hay errores en filas
    const hayErroresEnRows = rowErrors.some(
      (rowErr) => Object.keys(rowErr).length > 0
    );

    if (Object.keys(errors).length > 0 || hayErroresEnRows) {
      setFormErrors(errors); // esto debería usarse en los inputs del form
      setRowErrors(rowErrors); // deberías tener esto en cada fila de tu tabla
      Swal.fire({
        title: "Faltan datos",
        text: "Por favor, completa todos los campos obligatorios.",
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }
    //Validacion y formato del vuelo
    const vueloRegex = /^[A-Z]{2}\d{4}\/\d{2}[A-Z]{3}$/;
    const vuelos = rows.map((row) => row.flight.trim().toUpperCase());

    const vuelosConFormato = vuelos.map((v) => {
      // Autocompletado: LL123/24APR => LL0123/24APR
      const [aerolineaYNumero, fecha] = v.split("/");
      if (!aerolineaYNumero || !fecha) return v;

      const letras = aerolineaYNumero.slice(0, 2).toUpperCase();
      const numeros = aerolineaYNumero.slice(2).padStart(4, "0");
      return `${letras}${numeros}/${fecha.toUpperCase()}`;
    });

    // Validación de formato y duplicados
    const vuelosInvalidos = vuelosConFormato.filter((v) => !vueloRegex.test(v));
    const vuelosDuplicados = vuelosConFormato.filter(
      (v, i, self) => self.indexOf(v) !== i
    );

    if (vuelosInvalidos.length > 0) {
      Swal.fire({
        title: "Formato de vuelo inválido",
        text: `Verifica el/los vuelo(s): ${vuelosInvalidos.join(", ")}`,
        icon: "error",
        iconColor: "#ED1B1B",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    if (vuelosDuplicados.length > 0) {
      Swal.fire({
        title: "Vuelos Duplicados",
        text: `Los siguientes vuelos estan repetidos: ${vuelosDuplicados.join(
          ", "
        )}`,
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    //Aqui iria la logica para guardar los datos

    const house_id = Array.from(
      document.querySelectorAll("input[name='house_id[]']")
    ).map((input) => input.value);

    const house_hbs = Array.from(
      document.querySelectorAll("input[name='house_hbs[]']")
    ).map((input) => input.value);

    const house_pieces = Array.from(
      document.querySelectorAll("input[name='house_pieces[]']")
    ).map((input) => input.value);

    const house_gross_weight = Array.from(
      document.querySelectorAll("input[name='house_gross_weight[]']")
    ).map((input) => input.value);

    const house_chargeable_weight = Array.from(
      document.querySelectorAll("input[name='house_chargeable_weight[]']")
    ).map((input) => input.value);

    const house_volume = Array.from(
      document.querySelectorAll("input[name='house_volume[]']")
    ).map((input) => input.value);

    const house_description = Array.from(
      document.querySelectorAll("input[name='house_description[]']")
    ).map((input) => input.value);

    const house_merchandise_type = Array.from(
      document.querySelectorAll("input[name='house_merchandise_type_id[]']")
    ).map((input) => input.value);

    const fieldMap = {
      origenInicial: "origin",
      origen: "final_origin",
      piezas: "pieces",
      destino: "destiny",
      destinoFinal: "final_destination",
      grossWeight: "weight",
      chargeableWeight: "chargeable_weight",
      volumen: "volume",
      tipo: "merchandise_type",
      descripcion: "description",
      // agrega aquí los demás campos que necesites renombrar
    };

    // Crear objeto final con nombres correctos
    const datosFinales = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [
        fieldMap[key] || key,
        value,
      ])
    );

    datosFinales.flight = rows.map((row, index) => vuelosConFormato[index]);
    datosFinales.year = rows.map((row) => row.year);
    datosFinales.time = rows.map((row) => row.time);
    datosFinales.house_id = house_id;
    datosFinales.house_hbs = house_hbs;
    datosFinales.house_pieces = house_pieces;
    datosFinales.house_gross_weight = house_gross_weight;
    datosFinales.house_chargeable_weight = house_chargeable_weight;
    datosFinales.house_volume = house_volume;
    datosFinales.house_description = house_description;
    datosFinales.house_merchandise_type = house_merchandise_type;
    const user_id = JSON.parse(localStorage.getItem("user"))?.id;
    datosFinales.master_id = master.id;
    datosFinales.user_id = user_id;
    const params = datosFinales;

    const parcial_pieces = house_pieces.reduce(
      (acc, val) => acc + Number(val || 0),
      0
    );
    const parcial_gross = house_gross_weight.reduce(
      (acc, val) => acc + Number(val || 0),
      0
    );
    const parcial_chargeable = house_chargeable_weight.reduce(
      (acc, val) => acc + Number(val || 0),
      0
    );

    // Obtener valores de la master
    const pieces_master = Number(formData.piezas || 0);
    const gross_master = Number(formData.grossWeight || 0);
    const chargeable_master = Number(formData.chargeableWeight || 0);

    let errorMsg = [];
    let flag = false;

    // Validaciones
    if (pieces_master < parcial_pieces) {
      errorMsg.push(
        "Las piezas de la master no pueden ser menor a la suma de las piezas de las houses, favor de verificar"
      );
      flag = true;
    }
    if (gross_master < parcial_gross) {
      errorMsg.push(
        "El gross weight de la master no puede ser menor a la suma de las houses, favor de verificar"
      );
      flag = true;
    }
    if (chargeable_master < parcial_chargeable) {
      errorMsg.push(
        "El chargeable weight de la master no puede ser menor a la suma de las houses, favor de verificar"
      );
      flag = true;
    }

    // Mostrar alerta si hubo errores
    if (flag) {
      setError(errorMsg);
      return;
    }
    setError([]);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/upd_save/2`,
        params,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.error === false) {
        Swal.fire({
          title: "Guardado",
          text: "Los datos han sido guardados correctamente.",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const eliminarAlert = () => {
    Swal.fire({
      title: `¿Quieres eliminar la master ${master.master}?`,
      text: "",
      html: '<div class="alert-text">Esta acción es irreversible</div>',
      iconColor: "#ED1B1B",
      customClass: {
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title",
        popup: "alert-bg",
      },
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          master_id: master.id,
        };

        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/delete_exp_master`,
            {
              params: params,
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token") || ""
                  }`,
              },
            }
          );

          if (response.data.error === false) {
            Swal.fire({
              title: "¡Eliminado!",
              text: `${response.data.body.message}`,
              icon: "success",
              iconColor: "#1B9925",
              customClass: {
                confirmButton: "btn-ok",
                title: "alert-title",
                popup: "alert-bg",
              },
            }).then(() => {
              onBack(); 
            });
          }
        } catch (error) {
          Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        }
      }
    });
  };

  const editarAlert = (house) => {
    const merchandiseOptions = dataMaster.merchandise_types
      .map(
        (type) =>
          `<option value="${type.id}" ${type.id === house.merchandise_type_id ? "selected" : ""
          }>${type.name}</option>`
      )
      .join("");

    Swal.fire({
      title: "Editar Datos",
      html: `
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">HBS</label>
              <input id="hbs" class="form-control" value="${house.hbs}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Piezas</label>
              <input id="piezas" type="text" min="0" step="1" oninput="this.value=this.value.replace(/[^0-9]/g,'')" class="form-control" value="${house.pieces}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Gross Weight</label>
              <input id="grossWeight" class="form-control" type="text" step="0.01" oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\\..*)\\./g,'$1')" value="${house.gross_weight}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Chargeable Weight</label>
              <input id="chargeableWeight" class="form-control" type="text" oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\\..*)\\./g,'$1')" value="${house.chargeable_weight}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Volumen</label>
              <input id="volumen" class="form-control" type"text" oninput="this.value=this.value.replace(/[^0-9.]/g,'').replace(/(\\..*)\\./g,'$1')" value="${house.volume}" />
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Tipo de mercancía</label>
              <select id="tipo" class="form-select">
                ${merchandiseOptions}
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label class="form-label fw-bold text-start">Descripción</label>
              <textarea id="descripcion" class="form-control" rows="2">${house.description}</textarea>
            </div>
            <div class="col-12 mb-2">
              <div id="error-normal" class="text-danger mt-2 alert alert-danger text-left d-none"></div>
            </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      allowOutsideClick: true, 
      allowEscapeKey: true,    
      customClass: {
        popup: "form-alert-popup",
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title",
      },
      didOpen: () => {
        const plusIcon = document.getElementById("plusIcon");
        if (plusIcon)
          createRoot(plusIcon).render(<FaPlus style={{ color: "white" }} />);
      },
      preConfirm: () => {
        const formValues = {
          hbs: document.getElementById("hbs").value,
          piezas: document.getElementById("piezas").value,
          grossWeight: document.getElementById("grossWeight").value,
          chargeableWeight: document.getElementById("chargeableWeight").value,
          volumen: document.getElementById("volumen").value,
          tipo: document.getElementById("tipo").value,
          descripcion: document.getElementById("descripcion").value,
        };
        const errorDiv = document.getElementById("error-normal");

        for (const [key, value] of Object.entries(formValues)) {
          if (!value) {
            errorDiv.textContent = `El campo "${key}" es obligatorio`;
            errorDiv.classList.remove("d-none");
            return false; // detiene el modal hasta que se corrija
          }
        }

        const parcial_pieces = Number(formValues.piezas);
        const parcial_gross = Number(formValues.grossWeight);
        const parcial_chargeable = Number(formValues.chargeableWeight);

        const pieces_master = Number(formData.piezas || 0);
        const gross_master = Number(formData.grossWeight || 0);
        const chargeable_master = Number(formData.chargeableWeight || 0);

        // Validaciones
        if (pieces_master < parcial_pieces) {
          errorDiv.textContent =
            "Las piezas de la master no pueden ser menor a la suma de las piezas de las houses, favor de verificar";
          errorDiv.classList.remove("d-none");
          return false;
        }
        if (gross_master < parcial_gross) {
          errorDiv.textContent =
            "El gross weight de la master no puede ser menor a la suma de las houses, favor de verificar";
          errorDiv.classList.remove("d-none");
          return false;
        }
        if (chargeable_master < parcial_chargeable) {
          errorDiv.textContent =
            "El chargeable weight de la master no puede ser menor a la suma de las houses, favor de verificar";
          errorDiv.classList.remove("d-none");
          return false;
        }

        return formValues;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Guardar los cambios directamente en el objeto house
        setHousesState((prev) =>
          prev.map((h) =>
            h.id === house.id
              ? {
                ...h,
                hbs: result.value.hbs,
                pieces: result.value.piezas,
                gross_weight: result.value.grossWeight,
                chargeable_weight: result.value.chargeableWeight,
                volume: result.value.volumen,
                merchandise_type_id: Number(result.value.tipo),
                description: result.value.descripcion,
              }
              : h
          )
        );
      }
    });
  };

  const deleteAlert = (houseId) => {
    Swal.fire({
      title: "¿Seguro que desea eliminar la house?",
      html: '<div class="alert-text">Esta acción es irreversible al dar clic en Aceptar, ¿Deseas continuar?</div>',
      iconColor: "#ED1B1B",
      customClass: {
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title",
        popup: "alert-bg custom-width",
      },
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {

        setHousesState((prev) => prev.filter((h) => h.id !== houseId));

        Swal.fire({
          title: "¡Eliminado!",
          text: "La house fue eliminado.",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    });
  };

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        <>
          <div className="row mb-3">
            <div className="col-12 text-end">

              {Number(formData.tipo) === 19 ? (
                <ContenedoresActivos id={dataMaster.master.id} />
              ) : ""}

              <button
                className="btn btn-amc-pink botonEliminar"
                onClick={eliminarAlert}
              >
                Eliminar guía
              </button>
            </div>
          </div>

          {/* inputs y selects */}
          <div className="row mb-4">
            {[
              { label: "Master", key: "master" },
              { label: "Origen inicial", key: "origenInicial" },
              { label: "Origen", key: "origen" },
              { label: "Destino", key: "destino" },
              { label: "Destino final", key: "destinoFinal" },
              { label: "Piezas Master", key: "piezas" },
              { label: "Gross Weight Master", key: "grossWeight" },
              { label: "Chargeable Weight Master", key: "chargeableWeight" },
              { label: "Volumen Master", key: "volumen" },
              { label: "Tipo de mercancia", key: "tipo" },
              { label: "Descripción Master", key: "descripcion" },
            ].map((item, index) => {
              const isAlwaysReadOnly = [0].includes(index);
              const isReadOnly = isAlwaysReadOnly;
              return (
                <div key={index} className="col-md-4 mb-3">
                  <label className="form-label fw-bold">{item.label}</label>

                  {item.key === "tipo" ? (
                    <>
                      <select
                        className="form-select"
                        value={formData.tipo}
                        onChange={(e) =>
                          handleInputChange("tipo", e.target.value)
                        }
                      >
                        {merchandise_types.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                      {formErrors.tipo && (
                        <small className="text-danger">{formErrors.tipo}</small>
                      )}
                    </>
                  ) : item.key === "descripcion" ? (
                    <>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={formData.descripcion}
                        onChange={(e) =>
                          handleInputChange("descripcion", e.target.value)
                        }
                      />
                      {formErrors.descripcion && (
                        <small className="text-danger">
                          {formErrors.descripcion}
                        </small>
                      )}
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        className={`form-control ${isReadOnly ? "fondoInput" : ""
                          }`}
                        readOnly={isReadOnly}
                        value={formData[item.key]}
                        maxLength={
                          [
                            "origenInicial",
                            "origen",
                            "destino",
                            "destinoFinal",
                          ].includes(item.key)
                            ? 3
                            : undefined
                        }
                        onChange={(e) => {
                          const value = e.target.value;

                          if (item.key === "piezas") {
                            if (/^\d*$/.test(value)) {
                              handleInputChange("piezas", value);
                            }
                          } else if (
                            [
                              "grossWeight",
                              "chargeableWeight",
                              "volumen",
                            ].includes(item.key)
                          ) {
                            if (/^\d*\.?\d*$/.test(value)) {
                              handleInputChange(item.key, value);
                            }
                          } else if (
                            [
                              "origenInicial",
                              "origen",
                              "destino",
                              "destinoFinal",
                            ].includes(item.key)
                          ) {
                            const upper = value.toUpperCase();
                            if (/^[A-Z]{0,3}$/.test(upper)) {
                              handleInputChange(item.key, upper);
                            }
                          } else {
                            handleInputChange(item.key, value);
                          }
                        }}
                      />
                      {formErrors[item.key] && (
                        <small className="text-danger">
                          {formErrors[item.key]}
                        </small>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>

          {master.entry_date && (
            <div className="col-md-12 mt-2 mb-2">
              <div class="alert alert-warning">
                La master ya reportó una entrada de conectividad SAT, para
                agregar una irregularidad, comuníquese con el proveedor dando
                clic en el siguiente enlace{" "}
                <a
                  href="https://www.fabricadesoluciones.com/ticketing/horus/incidents-create"
                  target="_black"
                >
                  "Ticketing Horus"
                </a>
              </div>
            </div>
          )}

          {/* tabla */}
          <div className="row mb-4">
            <div className="col-12">
              <table
                className="table text-center mx-auto"
                style={{ maxWidth: "900px", width: "100%" }}
              >
                <thead className="table-light fondo-headUPD">
                  <tr style={{ fontSize: "13px" }}>
                    <th>HBS</th>
                    <th>Piezas</th>
                    <th>Gross Weight</th>
                    <th>Chargeable Weight</th>
                    <th>Volumen</th>
                    <th>Tipo de mercancia</th>
                    <th>Descripción</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {housesState?.length > 0 ? (
                    housesState.map((house) => {
                      // const hasInvoice = !!exp_invoices.some(
                      //   (inv) => Number(inv.exp_house_id) === house.id
                      // );

                      return (
                        <tr key={house.id} id={`tr_${house.id}`}>
                          <td>
                            <span id={`label_hbs_${house.id}`}>
                              {house.hbs}
                            </span>
                            <input
                              type="hidden"
                              name="house_hbs[]"
                              value={house.hbs}
                            />
                            <input
                              type="hidden"
                              name="house_id[]"
                              value={house.id}
                            />
                          </td>
                          <td>
                            <span
                              id={`label_pieces_${house.id}`}
                              className="label_pieces"
                            >
                              {house.pieces}
                            </span>
                            <input
                              type="hidden"
                              name="house_pieces[]"
                              value={house.pieces}
                            />
                          </td>
                          <td>
                            <span
                              id={`label_gross_weight_${house.id}`}
                              className="label_gross"
                            >
                              {house.gross_weight}
                            </span>
                            <input
                              type="hidden"
                              name="house_gross_weight[]"
                              value={house.gross_weight}
                            />
                          </td>
                          <td>
                            <span
                              id={`label_chargeable_weight_${house.id}`}
                              className="label_chargeable"
                            >
                              {house.chargeable_weight}
                            </span>
                            <input
                              type="hidden"
                              name="house_chargeable_weight[]"
                              value={house.chargeable_weight}
                            />
                          </td>
                          <td>
                            <span id={`label_volume_${house.id}`}>
                              {house.volume}
                            </span>
                            <input
                              type="hidden"
                              name="house_volume[]"
                              value={house.volume}
                            />
                          </td>
                          <td>
                            <span id={`label_merchandise_type_id_${house.id}`}>
                              {merchandise_types.find(
                                (m) => m.id === house.merchandise_type_id
                              )?.name || ""}
                            </span>
                            <input
                              type="hidden"
                              name="house_merchandise_type_id[]"
                              value={house.merchandise_type_id ?? ""}
                            />
                          </td>
                          <td>
                            <span id={`label_description_${house.id}`}>
                              {house.description}
                            </span>
                            <input
                              type="hidden"
                              name="house_description[]"
                              value={house.description}
                            />
                          </td>
                          <td>
                            <div className="d-flex justify-content-center gap-1">
                              <button
                                className="btn-pink-secondary custom-btn"
                                onClick={() => editarAlert(house)}
                              >
                                <FaPencil />
                              </button>

                              <button
                                className="btn-pink-secondary custom-btn"
                                onClick={() => deleteAlert(house.id)}
                              >
                                <FaTimes />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={8}>No hay houses para este master</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Tabla con filas dinamicas */}
          <div className="row mt-4 mb-4">
            <div className="col-md-12">
              <table
                className="table mx-auto"
                style={{ maxWidth: "800px", width: "100%" }}
              >
                <thead className="table-light fondo-headUPD">
                  <tr>
                    <th>* Vuelo</th>
                    <th>* Año</th>
                    <th>* Hora Vuelo</th>
                    <th>Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className={`form-control ${rowErrors[index]?.flight ? "is-invalid" : ""
                            }`}
                          value={row.flight}
                          onChange={(e) =>
                            handleRowInputChange(
                              index,
                              "flight",
                              e.target.value
                            )
                          }
                        />
                        {rowErrors[index]?.flight && (
                          <div className="invalid-feedback">
                            {rowErrors[index].flight}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          className={`form-select ${rowErrors[index]?.year ? "is-invalid" : ""
                            }`}
                          value={row.year}
                          onChange={(e) =>
                            handleRowInputChange(index, "anio", e.target.value)
                          }
                        >
                          {anioOptions.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                        {rowErrors[index]?.year && (
                          <div className="invalid-feedback">
                            {rowErrors[index].year}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="time"
                          className={`form-control ${rowErrors[index]?.time ? "is-invalid" : ""
                            }`}
                          value={row.time}
                          onChange={(e) =>
                            handleRowInputChange(index, "time", e.target.value)
                          }
                        />
                        {rowErrors[index]?.time && (
                          <div className="invalid-feedback">
                            {rowErrors[index].time}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        <button
                          className="btn iconoTrash"
                          onClick={() => handleDeleteRow(index)}
                        >
                          <FaTrashAlt />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="text-center mt-3">
                <button className="btnn" onClick={handleAddRow}>
                  <FaPlus />
                </button>
              </div>
            </div>
          </div>

          {error.length > 0 && (
            <div className="text-danger mt-2 alert alert-danger text-left">
              <ul className="mb-0">
                {error.map((err, index) => (
                  <li key={index}>{err}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="row mb-3">
            <div className="col text-end">
              <button className="btnn" onClick={guardarAlert}>
                Guardar
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col text-end">
              <button
                type="button"
                onClick={handleRedirectToPreCapture}
                rel="noopener noreferrer"
                className="btn p-0 m-0 botonIr"
              >
                Ir a precaptura de la guía 123-12345678
              </button>
            </div>
          </div>
        </>
      </div>
    </>
  );
}

export default Consolidated;
